// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_14-2";
export var blackBorderOnHover = "_14-7";
export var cell = "_14-6";
export var cellContainer = "_14-3";
export var checked = "_14-8";
export var disabled = "_14-5";
export var featuredIconCellContainer = "_14-9";
export var featuredIconTextContainer = "_14-b";
export var featuredIconWrapper = "_14-a";
export var noBorder = "_14-c";
export var orangeSelectedRow = "_47-3";
export var overflowableText = "_14-0";
export var overflowableTextContainer = "_14-1";
export var row = "_15-0";
export var rowCheckboxCell = "_14-4";
export var selectableTable = "_47-2";